import { React, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { handleUnauthenticated, isAuthenticated } from '../../util/auth'
import { useUserData } from '../user/useUserData'
import { trackLoadAnAuthenticatedPage } from '../../util/analytics'

import {
  selectUserObject,
  selectUserCallStatus,
  fetchUser,
} from '../user/userSlice'
import {
  selectProfilePictureImage,
  selectProfilePictureStatus,
  fetchProfilePicture
} from '../user/profilePictureSlice'

const AuthGuard = (WrappedComponent) => {
  function AuthenticatedComponent(props) {
    const currentPath = window.location.pathname // Google Analytics
    if (!isAuthenticated()) {
      handleUnauthenticated()
      return false
    }
    sessionStorage.setItem('wasLoggedIn', 'true')

    const { userObjData, userProfilePictureData, isUserDataLoading } = useUserData(
      selectUserObject,
      selectUserCallStatus,
      selectProfilePictureImage,
      selectProfilePictureStatus,
      fetchUser,
      fetchProfilePicture,
      useSelector,
      useDispatch
    )
    const userObjStatus = useSelector(selectUserCallStatus)
    const dispatch = useDispatch()

    useEffect(() => {
      if (userObjStatus === 'idle') {
        dispatch(fetchUser())
      }
    }, [userObjStatus, dispatch, fetchUser])

    // Google Analytics

    useEffect(() => {
      let trackedPages = JSON.parse(sessionStorage.getItem('trackedPages')) || {}

      if (!trackedPages[currentPath]) {
        trackLoadAnAuthenticatedPage('authenticated_page_loaded', currentPath)
        trackedPages = {}
        trackedPages[currentPath] = true
        sessionStorage.setItem('trackedPages', JSON.stringify(trackedPages))
      }
    }, [currentPath])

    return (
      <WrappedComponent
          /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...props}
        userObjData={userObjData}
        userProfilePictureData={userProfilePictureData}
        isUserDataLoading={isUserDataLoading}
      />
    )
  }

  return AuthenticatedComponent
}

export default AuthGuard
